module.exports = __webpack_public_path__ + "img/studyTip.77bf2010.png";